import {
  faBriefcase,
  faGraduationCap,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

import { FormattedMessage } from 'react-intl';
import React from 'react';
import JOB_TYPE from '../types/JobType.enum';
import Job from './Job';
import Title from './UI/Title';
import jobs from '../assets/data/jobs';

/**
 * ## List of jobs i had over the years.
 * @returns
 */
function JobHistory() {
  function getIcon(value: number) {
    switch (value) {
      case JOB_TYPE.JOB:
        return faBriefcase;
      case JOB_TYPE.GRADUATION:
        return faGraduationCap;
      default:
        return faUser;
    }
  }
  return (
    <div className="row">
      <div className="col-12">
        <Title
          level={2}
          custom
          css="text-uppercase pb-5 mb-0 text-left text-sm-center ft-wt-600"
        >
          <FormattedMessage id="about.experience" />
        </Title>
      </div>
      {jobs.map((job) => (
        <Job job={job} icon={getIcon(job.type)} key={job.year} />
      ))}
    </div>
  );
}

export default JobHistory;
